module.exports = __webpack_public_path__ + "bfe8bdfe33b4d058ebbc4e29d35fa7d4.jpg";